import me from '../../../assets/images/me.jpg'
import rocket from '../../../assets/images/rocket_vector.png'
import astronaut from '../../../assets/images/astronaut_vector.png'
import bgAbout from '../../../assets/images/bg-about.jpg'
import { Fade } from 'react-awesome-reveal'

import './style.css'

function About() {
    return(
        <section id="about_me" className='section w-100 ov-hidden fullscreen-section' style={{ backgroundImage: `url(${bgAbout})` }}>
            <div className='container'>
                <Fade direction='up' triggerOnce={true}>
                    <div className='section-title'>
                        <span className='text-secondary'>01. </span>
                        <span>About Me</span>
                    </div>

                    <div className='info'>
                        <img src={me} alt="Profile" title="That's me! :)" />
                        <span className='presentation-text'>
                            <span>
                                I am a <span className='text-secondary'>Front-end Developer</span> with over <span className='text-secondary'>8 years</span> of experience building <span className='text-secondary'>scalable</span> web applications, with a strong focus on <span className='text-secondary'>React</span>, <span className='text-secondary'>Vue.js</span> and advanced <span className='text-secondary'>CSS</span>.
                            </span>
                            <span>
                                I've worked in <span className='text-secondary'>international</span> teams, most recently at <span className='text-secondary'>Norwegian Cruise Line</span>, where I contributed to building a <span className='text-secondary'>Design System</span> and <span className='text-secondary'>reusable</span> component library from scratch. I care deeply about interface <span className='text-secondary'>architecture</span>, code <span className='text-secondary'>quality</span>, and delivering <span className='text-secondary'>consistent</span> user <span className='text-secondary'>experiences</span> across products.
                            </span>
                            <span>
                                I also <span className='text-secondary'>actively</span> use <span className='text-secondary'>AI</span> tools in my development <span className='text-secondary'>workflow</span>, not as a shortcut, but as a way to move <span className='text-secondary'>faster</span> while keeping high <span className='text-secondary'>standards</span>.
                            </span>
                            <span>
                                If you're looking for a <span className='text-secondary'>developer</span> who thinks about both the <span className='text-secondary'>code</span> and the <span className='text-secondary'>experience</span> behind it, let's talk.
                            </span>
                        </span>
                    </div> 
                </Fade>
            </div>
            <img src={astronaut} alt="Astronaut Vector" className='astronaut hide-mobile' title="Yooo!" />
            <img src={rocket} alt="Rocket Vector" className='rocket hide-mobile' title="TO INFINITY AND BEYOND!"/>
        </section>
    )
}

export default About